import React from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import { CampaignOffer } from '../../api/types';
import { formatPrice } from '../../money';

type OfferCardProps = {
  offer: CampaignOffer;
  onBuy: (sku: string) => void;
};

export function OfferCard({ offer, onBuy }: OfferCardProps) {
  return (
    <Card className="external-sales-offer-card h-100 shadow-sm border-0">
      <Card.Img variant="top" src={offer.imageUrl} alt={offer.name} />
      <Card.Body className="d-flex flex-column">
        {offer.bannerText && (
          <Badge variant="warning" className="align-self-start mb-2 px-2 py-1">{offer.bannerText}</Badge>
        )}
        <Card.Title className="h5">{offer.name}</Card.Title>
        {offer.subtitle && <Card.Subtitle className="mb-2 text-muted">{offer.subtitle}</Card.Subtitle>}
        {offer.description && <Card.Text className="text-muted">{offer.description}</Card.Text>}
        <div className="mt-auto">
          <div className="h4 mb-3">{formatPrice(offer.price)}</div>
          <Button variant="primary" block onClick={() => onBuy(offer.sku)}>Buy</Button>
        </div>
      </Card.Body>
    </Card>
  );
}
